import { useState } from 'react';
const paymentReminderModel = () => {
  const intialState = {
    batchId: 0,
    due: '',
    file: {
      id: '',
      fileName: '',
      loadDateTime: '',
      rowNos: 0,
      reminderStatus: '',
      startDate: '',
      endDate: '',
      fileLogs: [],
    },
    emailSender: { id: 0 },
    template: {
      id: 0,
    },
  };

  const [paymentReminder, setPaymentReminder] = useState(intialState);
  return {
    paymentReminder,
    setPaymentReminder,
    intialState,
  };
};

export default paymentReminderModel;
